import { useQuery } from "@tanstack/react-query";

import { getLeaderboardTimeframe } from "../../../../api/getLeaderboardTimeframe";
import { getPerformanceMetrics } from "../../../../api/getPerformanceMetrics";
import { getTodaySales } from "../../../../api/getTodaySales";
import { getTodayTimeframe } from "../../../../api/getTodayTimeframe";
import { getTotalCallCount } from "../../../../api/getTotalCallCount";
import { useSalesContext } from "../../../../sales-context/SalesContext";

export const useTotalCallCount = (scope: "week" | "today") => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`call-count`, scope],
        queryFn: async () =>
            getTotalCallCount(
                apiClients.gamification,
                scope === "today" ? getTodayTimeframe() : getLeaderboardTimeframe(),
            ),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};

export const usePerformanceMetrics = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`performance`],
        queryFn: async () => getPerformanceMetrics(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};

export const useTodaySales = () => {
    const { apiClients } = useSalesContext();
    const { data, isLoading, isError } = useQuery({
        queryKey: [`today-sales`],
        queryFn: async () => getTodaySales(apiClients.gamification),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
